<template>
  <div class="special_detail">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push('/')">
        <img src="../assets/img/logo.svg" alt="">
      </a>
      <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt="">
      </a>
    </div>
    <div class="tab_box">
      <ul>
        <li>
          <a href="javascript:;" class="tab_item" @click="$router.push('/')">
            首页
          </a>
          <i><img src="../assets/img/right.png" alt=""></i>
          <a href="javascript:;" class="tab_item">
            搜索列表
          </a>
        </li>
      </ul>
    </div>
    <div class="content">
      <div class="search">
        <input type="text" placeholder="搜索关键词" v-model="key">
        <a class="search_btn" href="javascript:;" @click="getListByPage(key,1)">搜索</a>
      </div>
      <ul class="msg_list">
        <li v-for="(item,index) in list" :key="index">
          <div class="msg_box" @click="goDetail(item)">
            <h3> {{item.currentCategoryName}}</h3>
            <p class="board" style="-webkit-box-orient: vertical;">{{item.title}}</p>
            <a class="msg_link" href="javascript:;">
              {{item.description}}
            </a>
          </div>
        </li>
      </ul>
      <div class="page" v-show="list&&list.length!=0">
        <div class="page_box">
          <div class="prev">
            <img v-if="page>1" src="../assets/img/prev.png" alt="" @click="prevPage()">
            <img v-if="page==1" src="../assets/img/prev_gray.png" alt="">
          </div>
          <div class="next">
            <img v-if="page<total" src="../assets/img/next.png" alt="" @click="nextPage()">
            <img v-if="page==total" src="../assets/img/next_gray.png" alt="">
          </div>
          <div class="page_msg">
            {{page}}/{{total}}页
          </div>
        </div>
      </div>
    </div>
    <detail-footer></detail-footer>
  </div>
</template>

<script>
import DetailFooter from './_footer'

export default {
  components: {
    DetailFooter
  },
  data () {
    return {
    	key:'',
      isChecked:1,
      list:[],
      size: 20,
      page:1,
      total:0 //分页总数
    }
  },
  mounted() {
    this.key = this.$route.query.key;
    this.getListByPage(this.key,1);
  },
  methods: {
    prevPage(){
      window.scrollTo(0,0);
      if(this.page>1){
        this.page = this.page - 1;
        this.getListByPage(this.key, this.page );
      } else{
        this.page = 1;
      }
    },
    nextPage(){
      window.scrollTo(0,0);
      if(this.page<this.total){
        this.page = this.page + 1;
        this.getListByPage(this.key, this.page );
      } else{
        this.page = this.total;
      }
    },
    getListByPage() {
      this.$axios.post('/api/web/phone/content/search', {
          key:this.key,
          page:this.page,
          size:this.size
        }).then((res)=>{
        this.total = res.data.pages;
        this.list = res.data.list;
      })
    },
    goDetail(item){
      if(!item.url){
        this.$router.push(`/detail/${item.contentId}/${this.isChecked}/0`);
      }else{
        window.open(item.url)
      }
    },
    goDetail(item){
      if(!item.url){
        // this.$router.push(`/detail/${item.contentId}/${this.isChecked}/0`);
        var num = item.categoryId;
        if(!item.currentCategoryFatherId){
          this.$router.push('/detail/'+item.contentId+'/'+item.currentCategoryId+'/'+0);
        }else{
          this.$router.push('/detail/'+item.contentId+'/'+item.currentCategoryId+'/'+item.currentCategoryFatherId);
        }
      }else{
        window.open(item.url)
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';

  .special_detail{
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
  }
 .header{
    height: 54px;
    background: rgb(255, 255, 255);
    border-bottom: 2px solid #f5f5f5;
    top: 0;
    left: 0;
    right: 0;
    position:fixed;
    z-index: 99;
    .logo{
      display: inline-block;
      // width: 133px;
      // height: 38px;
      position: absolute;
      top: 10px;
      left: 15px;
      img{
        height: 35px;
      }
    }
    .menu_btn{
      display: inline-block;
      position: absolute;
      top: 13px;
      right: 13px;
      width: 29px;
      height: 29px;
      img{
        width:100%;
        height:100%;
      }
    }
  }
  .tab_box{
    z-index: 99;
    top: 54px;
    left: 0;
    right: 0;
    position:fixed;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    background: #F5F5F5;
    text-align: left;
    overflow: hidden;
    ul{
      padding: 0;
      margin: 0;
      display: inline-block;
      border-bottom: 3px solid #df964d;
      width: 100%;
    }
    ul li{
      margin: 0;
      display: inline-block;
      padding: 0 10px;
    }
    i{
      display: inline-block;
      width: 6px;
      height: 100%;
      img{
        display: inline-block;
        width: 100%;
        position: relative;
        top: -1px;
      }
    }
    .tab_item{
      display: inline-block;
      padding: 15px 10px;
      color: #666666;
      font-size:16px;
      box-sizing: border-box;
      position: relative;
    }
  }
  .content {
    min-height: calc(100vh - 66px);
    box-sizing: border-box;
    padding-top: 108px;
    position: relative;
    padding-bottom: 70px;
    .search{
      position: relative;
      height: 57px;
      background: #EEEEEE;
      input{
        position: absolute;
        left: 15px;
        top: 10px;
        width:267px;
        height:37px;
        background:#fff;
        border-radius:5px;
        border:1px solid #CACACA;
        padding-left: 25px;
        box-sizing: border-box;
      }
      .search_btn{
        position: absolute;
        right: 15px;
        top: 10px;
        width:64px;
        height:37px;
        background: #0C324C;
        border-radius:5px;
        color: #fff;
        font-size: 16px;
        line-height: 37px;
      }
    }
    .msg_list{
      padding: 0 15px;
    }
    .msg_box{
      border-bottom: 1px solid #E0E0E0;
      padding: 15px 0;
      text-align: left;
      .board{
        line-height: 22px;
        font-size: 16px;
        max-height: 44px;
        overflow:hidden;
        color: #333;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .msg_link{
        display: inline-block;
        width: 100%;
        margin-top: 10px;
        color: #666666;
        overflow: hidden;
        line-height: 18px;
        height: 18px;
        font-size: 13px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .page{
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 25px;
      .page_box{
        position: relative;
        margin: 0 auto;
        width: 112px;
        color: #666666;
        font-size: 14px;
        .prev{
          position: absolute;
          left: 0;
          top: 2px;
          width: 16px;
          height: 16px;
        }
        .next{
          position: absolute;
          right:0;
          top: 2px;
          width: 16px;
          height: 16px;
        }
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .footer{
    box-sizing: border-box;
    height: 66px;
    background: #0C324C;
    padding: 12px 0;
    li{
      color: #fff;
      font-size: 13px;
      height: 18px;
      span{
        width:6px;
        display: inline-block;
        text-align: center;
      }
      a{
        color: #fff;
      }
    }
    .footer_tip{
      margin-top: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/search-list.vue